import { Fragment, useMemo, useState } from "react";
//-----------------------------------------------------
import { useMyStore } from "src/components/main/mainStore";
import { 
    myAxios, 
    MyFormData, 
    scroll, 
} from "src/components/common/functions";
import IncidentReport from "./form/incidentReport";
import { items as IncidentReportItems } from "./form/incidentReport";
import EquipmentDamageReport from "./form/equipmentDamageReport";
import { items as EquipmentDamageReportItems } from "./form/equipmentDamageReport";
import RentalForm from "./form/rentalForm";
import { items as RentalFormItems } from "./form/equipmentDamageReport";
import ReturnForm from "./form/returnForm";
import { items as ReturnFormItems } from "./form/equipmentDamageReport";
import GoodCatchForm from "./form/goodCatchForm";
import { items as GoodCatchFormItems } from "./form/goodCatchForm";
import NearMissForm from "./form/nearMissForm";
import { items as NearMissFormItems } from "./form/nearMissForm";
import CalibrationVerification from "./form/calibrationVerification";
import { items as CalibrationVerificationItems } from "./form/calibrationVerification";
import SafetyInspection from "./form/safetyInspection";
import { items as SafetyInspectionItems } from "./form/safetyInspection";
import WeeklyMaintenanceZerkFittings from "./form/weeklyMaintenanceZerkFittings";
import { items as WeeklyMaintenanceZerkFittingsItems } from "./form/weeklyMaintenanceZerkFittings";
import AuditForm from "./form/auditForm";
import { items as AuditFormItems } from "./form/auditForm";
//-----------------------------------------------------
export default function Detail({
    setUserList, 
    form, 
    history, 
    setHistory,
    setCurFormHashKey, 
    path2, 
    path1, 
    path3, 
    usersList, 
    usersListMap, 
    formSketches, 
    formSetSketches, 
    formPicData, 
    formSetPicData, 
    forms
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const user = useMyStore(state => state.user);
    const [comments, setComments] = useState("");
    const transformStr = arr => {
        const key = arr[0];
        const str = arr[1];
        let obj;
        try{
            obj = JSON.parse(str);
        }catch(e){
            if(key === "Tech") return usersListMap[str];
            return str;
        }
        if(Array.isArray(obj)){
            if(!obj.length) return "";
            return (
                <table className = "table mt-1 mb-3">
                    <thead>
                        <tr>
                            {Object.keys(obj[0]).map((v, k) => <th key = {k}>{v}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        {obj.map((o, k) => 
                        <tr key = {k}>
                            {Object.values(o).map((v, kk) => <th key = {kk}>{v}</th>)}
                        </tr>)}
                    </tbody>
                </table>
            )
        }else if(typeof(obj) === "number"){
            return str;
        }else{
            return (
                <table className = "table mt-1 mb-3">
                    <thead>
                        <tr>
                            {Object.keys(obj).map((v, k) => <th key = {k}>{v}</th>)}
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            {Object.values(obj).map((v, k) => <th key = {k}>{v}</th>)}
                        </tr>
                    </tbody>
                </table>
            )
        }
    }
    const deleteComment = async e => {
        if(!window.confirm("Are you sure to delete this comment?")) return;
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("commentHashKey", e.currentTarget.getAttribute("hashkey"));
        formData.append("submitterEmail", form.submitterEmail);
        //---------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/approval.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            res.data:
            f
        ));
    }
    const notifyUser = async() => {
        if(!window.confirm("Are you sure to notify the approver?")) return;
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("formId", form.id);
        formData.append("approverEmail", form.approverEmail);
        formData.append("updaterEmail", form.updaterEmail);
        //---------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/notify.php", formData)
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------
        setUserList(res.data);
        setCurFormHashKey(null);
        history.push(`/${path1}`);
        scroll(null);
    }
    const voidUser = async() => {
        if(!window.confirm("Are you sure to void this absence request")) return;
        let voidReason = window.prompt("reason to void:");
        if(voidReason === null) return;
        while(voidReason === ""){
            window.alert("Reason is required to void.");
            voidReason = window.prompt("reason to void:");
            if(voidReason === null) return;
        }
        const formData = new MyFormData();
        formData.append("formHashKey", form.formHashKey);
        formData.append("voidReason",voidReason);
        formData.append("formId", form.id);
        formData.append("approverEmail", form.approverEmail);
        formData.append("submitterEmail", form.submitterEmail);
        formData.append("updaterEmail", form.updaterEmail);
        //---------------------------------------------------------------
        setShowLoader(true);
        const res = await myAxios("forms/voidForm.php", formData);
        setShowLoader(false);
        if(!res) return;
        //---------------------------------------------------------------
        setUserList(forms => forms.map(f => 
            f.formHashKey === form.formHashKey?
            res.data:
            f
        ));
    }
    const closeIt = () => {
        history.push(`/${path1}/${path2}`);
    }
    const items = useMemo(() => {
        switch(form.formType){
            case "Incident Report":
                return IncidentReportItems;
            case "Equipment Damage Report":
                return EquipmentDamageReportItems;
            case "Rental Form":
                return RentalFormItems;
            case "Return Form":
                return ReturnFormItems;
            case "Good Catch Form":
                return GoodCatchFormItems;
            case "Near Miss Form":
                return NearMissFormItems;
            case "Calibration Verification Form":
                return CalibrationVerificationItems;
            case "Safety Inspection":
                return SafetyInspectionItems;
            case "Weekly Maintenance Zerk Fittings":
                return WeeklyMaintenanceZerkFittingsItems
            case "Audit Form":
                return AuditFormItems;
            default:
                return [];
        }
    }, [form.formType]);
    //--------------------------------------------------------------------------------------------
    const formContentObject = JSON.parse(form.formContent || "{}");
    return(
    <>
    <div className = "border rounded px-3">
        <div className = "mt-3">
            {items.filter(item => item.title !== "projectHashKey").map((item, itemIndex) => 
            item.type === "display"?<Fragment key = {itemIndex}>{item.content}</Fragment>:<li key = {itemIndex}>
                <span className = "font-weight-bold mr-3">{item.title.slice(-1) === "?"?item.title.slice(0, -1):item.title}:</span>
                {transformStr([item.title, formContentObject[item.title]])}
            </li>)}
        </div>
        <div>
            <table className = "table table-responsive-xl noTopBorder">
                <tbody>
                    {form.notify?<tr>
                        <th>Notified at</th>
                        <td>{form.notify}</td>
                    </tr>:<></>}
                    {form.void === "1"?<tr>
                        <th>Void Reason</th>
                        <td>{form.voidReason}</td>
                    </tr>:<></>}
                </tbody>
            </table>
            <div className = "mt-2 h4 text-info">Comments</div>
            <table className = "table table-responsive-xl noTopBorder">
            <colgroup>
                <col/>
            </colgroup>
                <tbody>
                    <tr>
                        <th
                            style = {{
                                whiteSpace: "pre-wrap"
                            }}
                        >
                            {!form.comments?"":
                            JSON.parse(form.comments)
                            .map((comment, commentIndex) => 
                            <div key = {commentIndex} className = "mb-2">
                                <span className = "text-info">
                                    {usersListMap?.[comment.email]}
                                </span>
                                :&nbsp;{comment.value}&nbsp;
                                <span className = "text-secondary">
                                    {comment.timeStamp}
                                </span>
                                &nbsp;{comment.email === user.email?
                                <span
                                    hashkey = {comment.hashKey}
                                    email = {comment.submitterEmail}
                                    onClick = {deleteComment}
                                    className = "btn btn-danger"
                                >
                                    Delete
                                </span>:<></>}
                            </div>)}
                        </th>
                    </tr>
                </tbody>
            </table>
        </div>
        
        {form.void === "1"?<></>:
        ([...usersList.filter(u => u.forms === "approver").map(u => u.email), form.submitterEmail].includes(user.email)?
        <div className = "text-right mb-3">
            <span className = "btn btn-danger mx-3" onClick = {voidUser}>Void</span>
            <span
                className = "btn btn-primary mx-3"
                onClick = {() => {
                    history.push(`/${path1}/${path2}/Edit`);
                }}
            >
                Edit
            </span>
            {form.status === "Submitted"?
            <span className = "btn btn-info mx-3" onClick = {notifyUser}>Notify</span>
            :<></>}
        </div>
        :<></>)
        }
        {form.void !== "1" && [...usersList.filter(u => u.forms === "approver").map(u => u.email), form.approverEmail].includes(user.email) && form.status !== "Created" && form.status !== "Saved"?<>
        <div className = "mb-3 font-weight-bold">Comments</div>
        <textarea
            className = "form-control w-100"
            rows = {4}
            value = {comments}
            onChange = {e => {setComments(e.currentTarget.value)}}
            name = "comments"
        />
        <div>
            <span
                className = {`btn btn-success m-3`}
                onClick = {async() => {
                    if(!comments){
                        window.alert("Comments are required.");
                        return;
                    }
                    if(!window.confirm("Are you sure to add this comment?")) return;
                    const formData = new MyFormData();
                    formData.append("formHashKey", form.formHashKey);
                    formData.append("comments", comments);
                    formData.append("submitterEmail", form.submitterEmail);
                    //----------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios("forms/approval.php", formData);
                    setShowLoader(false);
                    if(!res) return;
                    //----------------------------------------------------
                    setComments("");
                    setUserList(forms => forms.map(f => 
                        f.formHashKey === form.formHashKey?
                        res.data:
                        f
                    ));
                }}
            >Send</span>
        </div>
        <div>
            {!form.dateCompleted?
            <span className = {`btn btn-primary m-3`} onClick = {async() => {
                if(!window.confirm("Are you sure to set this request complete?")) return;
                const formData = new MyFormData();
                formData.append("formHashKey", form.formHashKey);
                //---------------------------------------------------------------
                setShowLoader(true);
                const res = await myAxios("forms/complete.php", formData);
                setShowLoader(false);
                if(!res) return;
                //---------------------------------------------------------------
                setUserList(forms => forms.map(f => 
                    f.formHashKey === form.formHashKey?
                    res.data:
                    f
                ));
                setHistory(true);
                
            }}>Complete</span>
            :<></>}
        </div>
        </>:<></>}
    </div>
    {path3 === "Edit" && usersList.length?<>
        {form.formType === "Incident Report"?
        <IncidentReport
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Equipment Damage Report"?
        <EquipmentDamageReport
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Rental Form"?
        <RentalForm
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Return Form"?
        <ReturnForm
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}

            rentalForms = {forms.filter(form => form.formType === "Rental Form" && form.void !== "1")}
        />:<></>}
        {form.formType === "Good Catch Form"?
        <GoodCatchForm
            closeIt = {closeIt}
            form = {form}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Near Miss Form"?
        <NearMissForm
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Calibration Verification Form"?
        <CalibrationVerification
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Safety Inspection"?
        <SafetyInspection
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}
        />:<></>}
        {form.formType === "Weekly Maintenance Zerk Fittings"?
        <WeeklyMaintenanceZerkFittings
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}

            forms = {forms.filter(form => form.formType === "Weekly Maintenance Zerk Fittings")}
        />:<></>}
        {form.formType === "Audit Form"?
        <AuditForm
            closeIt = {closeIt}
            form = {form}
            sketches = {formSketches}
            setSketches = {formSetSketches}
            picData = {formPicData} 
            setPicData = {formSetPicData}
            setUserList = {setUserList}
            usersList = {usersList}

            forms = {forms.filter(form => form.formType === "Audit Form")}
        />:<></>}
    </>:<></>}
    </>
    )
}
